import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import classOptionsImg from '../../images/service/service/Class Option.webp'
import onlineClassImg from '../../images/service/service-sub-pages/Class Option.jpg'
import banner5 from '../../images/banners/5.webp'
import './style.css'

const ClassOptions = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Class Options'} pagesub={'Service'} backgroundImage={banner5} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={classOptionsImg} alt="Class Options for Quran Learning"/>
                                </div>
                                <h2 className="service-title">Class Options</h2>
                                <div className="service-description">
                                    <p>At Dar-ul-Quran Academy, we understand that every student has unique learning needs and preferences. That's why we offer flexible class options designed to create the optimal learning environment for each individual. Choose the format that best suits your learning style, schedule, and goals.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={onlineClassImg} alt="Online Quran Class"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-mortarboard"></i> Our Learning Formats</h3>
                                        <h4 className="service-subsection-title">One-to-One Tutoring</h4>
                                        <p>Our most personalized learning experience, offering:</p>
                                        <ul className="service-features-list">
                                            <li>Complete focus on your specific learning needs and pace</li>
                                            <li>Immediate feedback and correction</li>
                                            <li>Customized lesson plans tailored to your strengths and areas for improvement</li>
                                            <li>Maximum flexibility in scheduling</li>
                                            <li>Faster progress through individualized attention</li>
                                            <li>Ideal for younger children, beginners, and serious students seeking rapid advancement</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h4 className="service-subsection-title">Small Group Classes (2-4 Students)</h4>
                                    <div className="service-section-content">
                                        <p>A collaborative learning environment with socialization benefits:</p>
                                        <ul className="service-features-list">
                                            <li>Learn alongside peers of similar age and level</li>
                                            <li>Benefit from healthy motivation and friendly competition</li>
                                            <li>Develop confidence through group recitation</li>
                                            <li>Learn from others' questions and challenges</li>
                                            <li>More affordable than one-to-one sessions</li>
                                            <li>Great for students who thrive in interactive settings</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-computer"></i> Our Online Platform</h3>
                                    <div className="service-section-content">
                                        <p>All classes are conducted via live video conferencing, offering a convenient yet effective learning experience:</p>
                                        <ul className="service-features-list">
                                            <li>Face-to-face interaction with tutors through high-quality video</li>
                                            <li>Interactive digital whiteboards for visual learning</li>
                                            <li>Screen sharing capabilities for digital Quran texts and materials</li>
                                            <li>Easy recording options to review lessons later</li>
                                            <li>Minimal technical requirements – just a computer or tablet with internet</li>
                                            <li>Digital resources and homework materials shared directly via email</li>
                                            <li>Parent observation possibility without disrupting the class</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-support"></i> Additional Support</h3>
                                    <div className="service-section-content">
                                        <ul className="service-features-list">
                                            <li>Digital textbooks and learning materials provided for all students</li>
                                            <li>Recorded lessons available on request for revision between classes</li>
                                            <li>Regular progress reports and feedback for parents/guardians</li>
                                            <li>Technical support for setting up and troubleshooting online sessions</li>
                                            <li>Option to switch between formats if your needs change</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>We're committed to providing a learning experience that feels personal and effective, regardless of physical distance. Our online classes bring the traditional Quranic education experience into your home while incorporating modern teaching techniques and technology to enhance learning outcomes. Whether you choose private lessons or small group classes, our qualified tutors will ensure you receive quality instruction and make steady progress toward your goals.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book a Free Trial Class</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/hifz">Previous: Hifz (Quran Memorisation)</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/free-demo">Next: Free Demo Class</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li className="current"><Link to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Book Your Free Trial Class</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default ClassOptions; 